import { IconWallet } from '@tabler/icons-react';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { useInvoiceSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/use-invoice-selection';
import { iconProps } from 'components/icon-props';
import { tKeys } from 'locales/index';
import type { InvoiceAction, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import { useHistory } from 'react-router-dom';
import type { ActionButtonDefinition } from '../use-build-action-buttons';
import { computeCommonProps } from './common';

export function usePaymentPlan(): (
  action: InvoiceAction,
  invoices: Array<UnhandledInvoice>,
) => ActionButtonDefinition {
  const debtor = useDebtor();
  const history = useHistory();
  const { selectedInvoiceIds } = useInvoiceSelection();

  return (action, invoices) => {
    const handler = () => {
      const queryParams = new URLSearchParams({
        debtor_id: String(debtor.id),
        invoice_ids: selectedInvoiceIds.join(','),
      }).toString();
      history.push(`/payment-plans/new?${queryParams}`);
    };

    return {
      icon: <IconWallet {...iconProps()} />,
      translationKey: tKeys.PAYMENT_PLAN.TITLE.ONE,
      onClick: handler,
      ...computeCommonProps(action, invoices),
    };
  };
}
